(function() {
    'use strict';

    angular.module("ib-MmB-transformers-module", []);
})();